module.exports = __webpack_public_path__ + "static/media/armadilhas.4562f953.png";